import { BillingStatus } from '@treadinc/horizon-api-spec';

import { useStores } from '~store';

// A suspended company (unpaid balance) is blocked from creating new work, so
// callers use this to disable create actions like New Order and New Project.
export default function useIsCompanySuspended() {
  const { userStore } = useStores();

  return userStore.userCompany.billingStatus === BillingStatus.SUSPENDED;
}
